import imgOutside from '../../assets/buildings/apartment/outside.png';
import imgWater from "../../assets/buildings/apartment/water.png";
import imgWaterFr from "../../assets/buildings/apartment/waterFr.jpg";
import imgWasteWater from '../../assets/buildings/apartment/waste-water.png';
import imgHeating from '../../assets/buildings/apartment/heating.png';
import imgFireProtection from '../../assets/buildings/apartment/fire-protection.png';
import { Building, BuildingTechSectors } from '../../interfaces/buildings';
import { ProductType } from '../products';
import { TechSector } from '../tech-sector';
import { activeLanguage } from '../../activeLanguage';

const frenchWater: BuildingTechSectors = {
            type: TechSector.WATER,
            img: imgWaterFr,
            products: [
                {
                        position: {x: 54, y: 418},
                    type: ProductType.MULTI_ECO
                },
                {
                        position: {x: 389, y: 583},
                    type: ProductType.HYA_RAIN_N
                },
                {
                        position: {x: 601, y: 643},
                    type: ProductType.DELTA_BASIC_COMPACT_MVP
                },
                {
                        position: {x: 982, y: 605},
                    type: ProductType.SISTO_16_RGAMAXX
                },
            ]
        }

const apartmentConfig: Building = {
    techSectors: [
    {
            type: TechSector.WASTE_WATER,
            img: imgWasteWater,
            products: [
                {
                        position: {x: 327, y: 873},
                    type: ProductType.AMA_DRAINER_4_5
                },
                {
                        position: {x: 719, y: 695},
                    type: ProductType.LEVELCONTROL_BASIC_2
                },
                {
                        position: {x: 1194, y: 834},
                    type: ProductType.MINI_COMPACTA
                },
                {
                        position: {x: 1391, y: 814},
                    type: ProductType.COMPACTA
                },
                {
                        position: {x: 1762, y: 718},
                    type: ProductType.AMA_DRAINER_BOX_UNTERFLUR
                },
            ]
        },
        {
            type: TechSector.FIRE_PROTECTION,
            img: imgFireProtection,
            products: [
                {
                        position: {x: 957, y: 808},
                    type: ProductType.HYADUO_2_D_FL_COMPACT
                },
            ]
        },
        {
            type: TechSector.HEATING,
            img: imgHeating,
            products: [
                {
                        position: {x: 264, y: 927},
                    type: ProductType.BOAX_S_SF
                },
                {
                        position: {x: 350, y: 864},
                    type: ProductType.SERIE_2000
                },
                {
                        position: {x: 470, y: 893},
                    type: ProductType.ETANORM
                },
                {
                        position: {x: 480, y: 119},
                    type: ProductType.BOA_CONTROL_PIC
                },
                {
                        position: {x: 564, y: 829},
                    type: ProductType.BOA_CONTROL_IMS
                },
                {
                        position: {x: 686, y: 815},
                    type: ProductType.SISTO_16_RGAMAXX
                },
                {
                        position: {x: 976, y: 807},
                    type: ProductType.CALIO_PRO_PLUS_Z
                },
                {
                        position: {x: 1122, y: 793},
                    type: ProductType.CALIO_PRO_PLUS
                },
                {
                        position: {x: 1172, y: 755},
                    type: ProductType.BOA_CONTROL_DPR
                },
                {
                        position: {x: 1229, y: 718},
                    type: ProductType.BOA_CONTROL_SBV
                },
                {
                        position: {x: 1323, y: 752},
                    type: ProductType.BOA_RVK
                },
                {
                        position: {x: 1446, y: 787},
                    type: ProductType.ETALINE_Z
                },
            ]
        },
        activeLanguage.locale.language === 'fr'
            ? frenchWater
            : {
            type: TechSector.WATER,
            img: imgWater,
            products: [
                {
                        position: {x: 102, y: 604},
                    type: ProductType.MULTI_ECO
                },
                {
                        position: {x: 498, y: 737},
                    type: ProductType.HYA_RAIN_2_PLUS
                },
                {
                        position: {x: 675, y: 823},
                    type: ProductType.DELTA_BASIC_COMPACT_MVP
                },
                {
                        position: {x: 1018, y: 759},
                    type: ProductType.SISTO_16_RGAMAXX
                },
            ]
        },
    ],
    img: imgOutside
}

export default apartmentConfig;
